import { fromJS } from 'immutable';

export default {
    setBoxes: (state, boxes) => {
        return state.mergeIn(['list'], fromJS(boxes)).set('initialized', true);
    },
    updateBox: (state, box) => {
        return state.mergeIn(['list'], fromJS(box));
    },
    updateBoxStatus: (state, macAddress, boxIsConnected) => {
        return state.setIn(['list', macAddress, 'boxIsConnected'], boxIsConnected);
    },
    setPrefixFheCenter: (state, prefixFheCenter) => {
        return state.setIn(['prefixFheCenter'], prefixFheCenter);
    },
    updateBoxIp: (state, macAddress, ipAddress) => {
        return state.setIn(['list', macAddress, 'privateIp'], ipAddress);
    },
    updateBoxSysInfo: (state, macAddress, boxSysInfo) => {
        return state.mergeIn(['list', macAddress], boxSysInfo);
    },
    updateZwaveStatus: (state, macAddress, zwaveStatus) => {
        return state.mergeIn(['list', macAddress, 'zwaveStatus'], zwaveStatus);
    },
    updateBoxUpgrade: (state, macAddress, upgrade) => {
        return state.setIn(['list', macAddress, 'upgrade'], upgrade);
    },
    swapBox: (state, payload) => {
        const newState = state.mergeIn(['list', payload.mac], { homeId: 0, boxState: 'inactive' });
        return newState.mergeIn(['list', payload.newMac], { homeId: payload.homeId, boxState: 'active' });
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Boxes/core.js